import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { RollbarService } from '../services/rollbar.service';

@Injectable()
export class RollbarInterceptor implements HttpInterceptor {
  constructor(private rollbarService: RollbarService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse && !this.isIgnoredStatus(error.status)) {
          this.rollbarService.log(
            new Error(`HTTP ${error.status} ${req.method} ${req.url}`),
            {
              message: error.message,
              status: error.status,
              url: req.url,
            }
          );
        }
        return throwError(() => error);
      })
    );
  }

  private isIgnoredStatus(status: number): boolean {
    return status >= 400 && status < 500;
  }
}
